import { supabase } from '../supabase/client';
import type { AktionEntwurf, AktionsStatus, TicketAktion } from './types';

export type AktionInsert = {
  ticket_id: string;
  typ: string;
  status: 'entwurf';
  freigabe_erforderlich: boolean;
  ist_rechtlich_sensibel: boolean;
  empfaenger: string | null;
  empfaenger_kontakt_id: string | null;
  betreff: string | null;
  entwurf_text: string | null;
  payload: Record<string, unknown>;
  ki_generiert: boolean;
  ki_confidence: number | null;
  erstellt_von: string | null;
};

// Rein & testbar (Muster wie baueTicketInsert).
export function baueAktionInsert(
  entwurf: AktionEntwurf, ticketId: string, erstelltVon: string | null,
): AktionInsert {
  return {
    ticket_id: ticketId,
    typ: entwurf.typ,
    status: 'entwurf',
    freigabe_erforderlich: entwurf.freigabe_erforderlich,
    ist_rechtlich_sensibel: entwurf.ist_rechtlich_sensibel,
    empfaenger: entwurf.empfaenger,
    empfaenger_kontakt_id: entwurf.empfaenger_kontakt_id,
    betreff: entwurf.betreff,
    entwurf_text: entwurf.entwurf_text,
    payload: entwurf.payload ?? {},
    ki_generiert: true,
    ki_confidence: entwurf.ki_confidence,
    erstellt_von: erstelltVon,
  };
}

// Dünne Supabase-Wrapper (Konvention: nicht unit-getestet).
export async function speichereAktionen(
  entwuerfe: AktionEntwurf[], ticketId: string, erstelltVon: string | null,
): Promise<void> {
  if (!entwuerfe.length) return;
  const rows = entwuerfe.map((e) => baueAktionInsert(e, ticketId, erstelltVon));
  const { error } = await supabase.from('ticket_aktionen').insert(rows);
  if (error) throw error;
}

export async function ladeAktionenFuerTicket(ticketId: string): Promise<TicketAktion[]> {
  const { data, error } = await supabase
    .from('ticket_aktionen').select('*')
    .eq('ticket_id', ticketId)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return (data || []) as TicketAktion[];
}

export async function setzeAktionStatus(
  aktionId: string, status: AktionsStatus, freigegebenVon: string | null = null,
): Promise<void> {
  // updated_at wird per DB-Trigger (ticket_aktionen_updated_at) gepflegt
  const patch: Record<string, unknown> = { status };
  if (status === 'freigegeben') {
    patch.freigegeben_von = freigegebenVon;
    patch.freigegeben_am = new Date().toISOString();
  }
  const { error } = await supabase.from('ticket_aktionen').update(patch).eq('id', aktionId);
  if (error) throw error;
}
